import { Component, Input, ViewContainerRef, ViewChild, Injector, ComponentFactoryResolver } from '@angular/core';
import { AccountCenterTemplateComponent } from './utilities/account-center-template.component';
import { TransitionPartialComponent } from './partials/transition-partial.component';
import { CorrectionPartialComponent } from './partials/correction-partial.component';

@Component({
  moduleId: module.id,
  selector: 'partial-include',
  entryComponents: [AccountCenterTemplateComponent, CorrectionPartialComponent, TransitionPartialComponent],
  template: ` <div #partialIncludeContainer></div> `,
})
export class PartialIncludeComponent {
  currentComponent = null;

  @ViewChild('partialIncludeContainer', { read: ViewContainerRef, static: true })
  partialIncludeContainer: ViewContainerRef;

  @Input() set componentData(data) {
    const page = data.page;
    const policy = data.policy;
    const inputProviders = [{ provide: 'policy', useValue: policy }];
    const injector = Injector.create(inputProviders);
    const factory = this.getComponentFactory(page);
    const component = factory.create(injector);
    this.partialIncludeContainer.insert(component.hostView);
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }
    this.currentComponent = component;
  }

  private getComponentFactory(page) {
    const primaryPage = page instanceof Array ? page[0] : page;
    switch (primaryPage) {
      case 'idCheck':
        return this.resolver.resolveComponentFactory(CorrectionPartialComponent);
      case 'mvr':
        return this.resolver.resolveComponentFactory(CorrectionPartialComponent);
      case 'accountCenterTemplate':
        return this.resolver.resolveComponentFactory(AccountCenterTemplateComponent);
      case 'transition':
        return this.resolver.resolveComponentFactory(TransitionPartialComponent);
      default:
        return this.resolver.resolveComponentFactory(AccountCenterTemplateComponent);
    }
  }
  constructor(private resolver: ComponentFactoryResolver) {}
}
